var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (ViewHelpers, show, showEvents, undefined) {
buf.push("<h1 class=\"sem-header\">Events</h1><div class=\"sem-events\">");
// iterate showEvents
;(function(){
  var $$obj = showEvents;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var showEvent = $$obj[$index];

buf.push("<div class=\"sem-event\"><h2 class=\"sem-event-title\">");
if ( showEvent.title)
{
buf.push("" + (jade.escape((jade_interp = showEvent.event_type) == null ? '' : jade_interp)) + " <em>" + (jade.escape((jade_interp = showEvent.title) == null ? '' : jade_interp)) + "</em>");
}
else
{
buf.push(jade.escape(null == (jade_interp = showEvent.event_type) ? "" : jade_interp));
}
buf.push("</h2><div class=\"sem-event-metadata\"><p>" + (jade.escape(null == (jade_interp = ViewHelpers.formatShowEventDateRange(showEvent.start_at, showEvent.end_at)) ? "" : jade_interp)) + "</p>");
if ( show.location)
{
buf.push("<p>" + (jade.escape(null == (jade_interp = ViewHelpers.singleLine(show.location)) ? "" : jade_interp)) + "</p>");
}
buf.push("</div>");
if ( showEvent.description)
{
buf.push("<div class=\"sem-event-description\"><p>" + (jade.escape(null == (jade_interp = showEvent.description) ? "" : jade_interp)) + "</p></div>");
}
buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var showEvent = $$obj[$index];

buf.push("<div class=\"sem-event\"><h2 class=\"sem-event-title\">");
if ( showEvent.title)
{
buf.push("" + (jade.escape((jade_interp = showEvent.event_type) == null ? '' : jade_interp)) + " <em>" + (jade.escape((jade_interp = showEvent.title) == null ? '' : jade_interp)) + "</em>");
}
else
{
buf.push(jade.escape(null == (jade_interp = showEvent.event_type) ? "" : jade_interp));
}
buf.push("</h2><div class=\"sem-event-metadata\"><p>" + (jade.escape(null == (jade_interp = ViewHelpers.formatShowEventDateRange(showEvent.start_at, showEvent.end_at)) ? "" : jade_interp)) + "</p>");
if ( show.location)
{
buf.push("<p>" + (jade.escape(null == (jade_interp = ViewHelpers.singleLine(show.location)) ? "" : jade_interp)) + "</p>");
}
buf.push("</div>");
if ( showEvent.description)
{
buf.push("<div class=\"sem-event-description\"><p>" + (jade.escape(null == (jade_interp = showEvent.description) ? "" : jade_interp)) + "</p></div>");
}
buf.push("</div>");
    }

  }
}).call(this);

buf.push("</div>");}.call(this,"ViewHelpers" in locals_for_with?locals_for_with.ViewHelpers:typeof ViewHelpers!=="undefined"?ViewHelpers:undefined,"show" in locals_for_with?locals_for_with.show:typeof show!=="undefined"?show:undefined,"showEvents" in locals_for_with?locals_for_with.showEvents:typeof showEvents!=="undefined"?showEvents:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;